import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currencyState: {
    data: [],
    isLoading: false,
    isSuccess: false,
  },
};

const commonSlice = createSlice({
  name: "common",
  initialState: initialState,
  reducers: {
    getCurrencies: (state) => {
      state.currencyState.isLoading = true;
    },
    getCurrenciesSuccess: (state, action) => {
      state.currencyState.data = action.payload;
      state.currencyState.isLoading = false;
      state.currencyState.isSuccess = true;
    },
    getCurrenciesFailed: (state, action) => {
      state.currencyState.data = [];
      state.currencyState.isLoading = false;
      state.currencyState.isSuccess = false;
    },
  },
});

export const { getCurrencies, getCurrenciesSuccess, getCurrenciesFailed } = commonSlice.actions;

export default commonSlice.reducer;
